export const ESN_SELECT_PROPS = {
  optionValue: 'ESN',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DICTIONARY_CATEGORY = {
  PREDIRECTIONAL: 'codeStreetDirections',
  POSTDIRECTIONAL: 'codeStreetDirections',
  STREET_TYPE: 'codeStreetTypes',
  CITY: 'codeCities',
  STATE: 'codeStates',
  UNIT_TYPE: 'codeAddressUnitTypes',
  ADDRESS_CATEGORY: 'codeAddressCategories',
  FLOOR_TYPE: 'codeAddressFloorTypes',
  BLDG_TYPE: 'codeAddressBldgTypes',
  ESN: 'cadESNs',
};

export const CLERY_LOCATION = {
  CAMPUS_RESIDENTIAL: 'CampusResidential',
  CAMPUS_NON_RESIDENTIAL: 'CampusNonResidential',
  NON_CAMPUS: 'NonCampus',
  PUBLIC: 'Public',
};

export const CLERY_LOCATION_OPTIONS = [
  { value: CLERY_LOCATION.CAMPUS_RESIDENTIAL, label: 'Campus Residential' },
  { value: CLERY_LOCATION.CAMPUS_NON_RESIDENTIAL, label: 'Campus Non-Residential' },
  { value: CLERY_LOCATION.NON_CAMPUS, label: 'Non-Campus' },
  { value: CLERY_LOCATION.PUBLIC, label: 'Public' },
];

export const ADDRESS_TAB_KEYS = {
  EDIT: 'edit',
  ATTACHMENTS: 'attachments',
  COORDINATES: 'coordinates',
  HISTORY: 'history',
  PARTIES: 'parties',
  PRE_PLAN: 'prePlan',
  SOPS: 'sops',
  ZONES: 'zones',
};

export const ADDRESS_TABS = [
  { key: ADDRESS_TAB_KEYS.EDIT, label: 'Edit Address' },
  { key: ADDRESS_TAB_KEYS.ATTACHMENTS, label: 'Attachments' },
  { key: ADDRESS_TAB_KEYS.COORDINATES, label: 'Coordinates' },
  { key: ADDRESS_TAB_KEYS.HISTORY, label: 'History' },
  { key: ADDRESS_TAB_KEYS.PARTIES, label: 'Parties' },
  { key: ADDRESS_TAB_KEYS.PRE_PLAN, label: 'Pre-Plan' },
  { key: ADDRESS_TAB_KEYS.SOPS, label: 'SOPs' },
  { key: ADDRESS_TAB_KEYS.ZONES, label: 'Zones' },
];

export const DEFAULT_VALUES = {
  AddressCategory: '',
  AddressNumberPrefix: '',
  AddressNumber: '',
  AddressNumberSuffix: '',
  PreDirection: '',
  StreetName: '',
  StreetType: '',
  PostDirection: '',
  ptsCityID: null,
  State: '',
  Postal: '',
  County: '',
  Country: '',
  Notes: '',
  UnitType: '',
  UnitIdentifier: '',
  FloorType: '',
  FloorIdentifier: '',
  BldgType: '',
  BldgIdentifier: '',
  ShowInEventLookup: false,
  SexOffender: false,
  Parolee: false,
  Probation: false,
  NonValidatedAddress: false,
  CleryLocationRadio: '',
  CrossStreet: '',
  Highway: '',
  ESN: '',
  Landmark: '',
  SurroundingArea: '',
  Area: '',
  Description: '',
  RangeDescription: '',
  MapLocation: '',
  RelativeLocation: '',
  AltitudeMeasure: '',
  DepthMeasure: '',
  GeographicElevation: '',
  MGRSCoordinate: '',
  UTMCoordinate: '',
  TwoDGeographicCoordinate: '',
};

export const FORM_DEFAULT_VALUES = {
  ...DEFAULT_VALUES,
  ptsAddressID: null,
  FullAddressText: '',
  Locale: '',
  CampusResidential: false,
  CampusNonResidential: false,
  NonCampus: false,
  Public: false,
};
